import { Button } from '@mantine/core';

export interface IButtonProps {
  onClick?: () => void;
  variant: 'outline' | 'filled';
  text: string;
  className?: string;
  disabled?: boolean;
}

function CommonButton({
  onClick,
  variant,
  text,
  className,
  disabled,
}: IButtonProps) {
  const variantStyles =
    variant === 'outline'
      ? 'border-gray-500 border-2 text-subtitle font-semibold hover:bg-white hover:border-primary-500 hover:text-primary-500'
      : 'bg-primary-500 hover:bg-primary-600 hover:border-primary-600 text-white font-semibold border-2 border-primary-500';

  return (
    <div className={disabled ? 'cursor-not-allowed' : 'cursor-pointer'}>
      <Button
        onClick={onClick}
        className={`px-8 py-2 h-fit rounded-lg select-none text-lg  text-center ${className} ${variantStyles} `}
        disabled={disabled}
      >
        <p>{text}</p>
      </Button>
    </div>
  );
}

export default CommonButton;
